package com.nonopn.skydome.common.app.pages.main.view.map

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material.OutlinedButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog

import com.nonopn.skydome.common.app.pages.main.model.api.Probe
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.no_probe_coverage_add_probe
import com.nonopn.skywatcher.common.app.res.no_probe_coverage_message
import com.nonopn.skywatcher.common.app.res.select_hint_dismiss
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.utils.localized
import com.nonopn.skywatcher.design.widgets.DefaultCard
import com.nonopn.skywatcher.maps.MapUtils

import eu.codlab.compose.widgets.TextNormal

private const val PROBE_COVERAGE_RADIUS_KM = 100.0

// Checks whether the given coordinates are within 100 km of any enabled probe
fun isWithinProbeCoverage(
    latitude: Double,
    longitude: Double,
    probes: List<Probe>
): Boolean = probes.any { probe ->
    probe.enabled &&
        MapUtils.distance(latitude, longitude, probe.latitude, probe.longitude) <=
        PROBE_COVERAGE_RADIUS_KM
}

@Composable
fun NoProbeCoverageDialog(
    onAddProbe: (() -> Unit)?,
    onDismiss: () -> Unit
) {
    Dialog(onDismissRequest = onDismiss) {
        DefaultCard(backgroundColor = AppColor.White) {
            Column(
                modifier = Modifier.padding(16.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                TextNormal(
                    text = Res.string.no_probe_coverage_message.localized(),
                    color = AppColor.StrikeText,
                    textAlign = TextAlign.Center
                )
                Spacer(Modifier.height(16.dp))
                // Adding probes is restricted to admin accounts for now
                if (onAddProbe != null) {
                    OutlinedButton(
                        modifier = Modifier.fillMaxWidth(),
                        onClick = onAddProbe
                    ) {
                        TextNormal(
                            text = Res.string.no_probe_coverage_add_probe.localized(),
                            color = AppColor.StrikePrimary
                        )
                    }
                    Spacer(Modifier.height(8.dp))
                }
                OutlinedButton(
                    modifier = Modifier.fillMaxWidth(),
                    onClick = onDismiss
                ) {
                    TextNormal(
                        text = Res.string.select_hint_dismiss.localized(),
                        color = AppColor.StrikeText
                    )
                }
            }
        }
    }
}
